import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const PostDetailsWrapper = styled.div`
  position: relative;

  &.image_left {
    @media (min-width: 991px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
    }
    .post_preview {
      margin-top: 0;
      @media (min-width: 991px) {
        flex: 0 0 42%;
        max-width: 42%;
        padding-right: 60px;
        margin: 0;
        &:before {
          width: calc(80% - 60px);
        }
      }
    }
    .post_des_wrapper {
      @media (min-width: 991px) {
        flex: 0 0 58%;
        max-width: 58%;
        margin: 0;
      }
      .post_des {
        margin-top: 60px;
      }
    }
  }
`;

export const PostTitle = styled.h1`
  font-size: 45px;
  font-weight: 700;
  color: ${themeGet('colors.textColor', '#292929')};
  line-height: 1.53;
  margin-bottom: 10px;
  @media (max-width: 1200px) {
    font-size: 40px;
    margin-bottom: 15px;
  }
  @media (max-width: 990px) {
    font-size: 36px;
    margin-bottom: 15px;
  }
  @media (max-width: 575px) {
    font-size: 28px;
    margin-bottom: 15px;
  }
`;
export const PostDate = styled.div`
  position: absolute;
  width: 75px;
  height: 75px;
  top: 30px;
  left: 30px;
  display: flex;
  text-align:center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 6px;
  font-size: 26px;
  font-weight: bold;
  line-height: 0.8;
  pointer-events: none;
  z-index: 1;
  background-color: rgba(209, 0, 104, 0.9 );
  div {
    > span {
      font-size: 13px;
      font-weight: normal;
      line-height: 1;
      margin-top: 3px;
    }
  }
  @media (max-width: 600px) {
    width: 50px;
    top: 10px;
    left: 10px;
    height: 50px;
    font-size: 18px;
    span {
      font-size: 10px;
    }
  }
`;

export const PostPreview = styled.div`
  margin-top: 45px;
  position: relative;
  @media (max-width: 1200px) {
    margin-top: 40px;
  }
  @media (max-width: 575px) {
    margin-top: 35px;
  }

  img {
    filter: grayscale(100%);
    &:hover {
      filter: unset;
    }
  }


  
  div.series {
    position:absolute;
    top: 0px;
    right:-10px;

    font-size: 12px;
    margin: 0 10px;
    padding: 0px 10px;
    font-family: 'Poppins';
    color: #000;
    background-color: #fff;

    cursor: pointer;
    
    text-transform: uppercase;

    span {
      margin-left: 5px;
      font-size: 18px;
      color:#D10068;
      font-weight: 600;
    }
    
    @media (max-width: 600px) {
      background-color: white;
      opacity: 0.8;
   
      > span {
        font-size: 12px;
      }
    }

    
  }
`;

export const PostDescriptionWrapper = styled.div`
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 870px;
  max-width: 100%;
  @media (max-width: 1200px) {
    margin-top: 70px;
  }
  @media (max-width: 575px) {
    margin-top: 30px;
  }
`;

export const PostDescription = styled.div`
  font-size: ${themeGet('fontSizes.4', '16')}px;

  .mermaid {
    margin-bottom: 60px;
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }

  p {
    font-size: ${themeGet('fontSizes.4', '16')}px;
    margin-bottom: 2em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
    margin-bottom: 0.75em;
  }

  h1 {
    font-size: 30px;
    margin-bottom: 0.75em;
  }

  h2 {
    font-size: 25px;
    margin-bottom: 0.75em;
  }

  h3 {
    font-size: 21px;
  }

  h4 {
    font-size: 17px;
  }

  h5 {
    font-size: 15px;
  }

  h6 {
    font-size: 13px;
  }

  ol,
  ul {
    margin-left: 1.5rem;
    margin-bottom: 2rem;
    line-height: 2;
  }

  li {
    margin-bottom: 0.45rem;

    p {
      margin-bottom: 1em;
    }
  }

  blockquote {
    font-family: 'Poppins', sans-serif;
    font-size: 21px;
    font-weight: 500;
    line-height: 2;
    margin: 60px 0;
    @media (max-width: 1200px) {
      margin: 50px 0;
      font-size: 19px;
    }  @media (max-width: 600px) {
      width: 50px;
      height: 50px;
      font-size: 18px;
      span {
        font-size: 10px;
      }
    }
      margin: 40px 0;
      font-size: 15px;
    }
    &:before,
    &:after {
      content: '';
      width: 30px;
      display: block;
      background: #292929;
    }
    &:before {
      margin-bottom: 60px;
      @media (max-width: 1200px) {
        margin-bottom: 50px;
      }
      @media (max-width: 575px) {
        margin-bottom: 40px;
      }
    }
    &:after {
      margin-top: 60px;
      @media (max-width: 1200px) {
        margin-top: 50px;
      }
      @media (max-width: 575px) {
        margin-top: 40px;
      }
    }

    p {
      font-size: 15px;
      
      line-height: 2;
      margin-bottom: 23px;
      @media (max-width: 1200px) {
        font-size: 19px;
      }
      @media (max-width: 1200px) {
        font-size: 17px;
      }
      @media (max-width: 575px) {
        font-size: 15px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    h4 {
      font-size: 16px;
      margin: 0;
      font-family: 'Fira Sans', sans-serif;
      font-weight: 400;
    }
  }

  a {
    font-weight: 500;
    transition: 0.15s ease-in-out;
    color: ${themeGet('primary', '#D10068')};
  }
`;

export const PostTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 60px;

  a {
    display: block;
    margin-right: 30px;
    font-size: 14px;
    font-weight: 400;
    color: ${themeGet('primary', '#D10068')};
  }
`;
// Random Placeholder Color
const placeholderColors = [
  '#55efc4',
  '#81ecec',
  '#74b9ff',
  '#a29bfe',
  '#ffeaa7',
  '#fab1a0',
  '#e17055',
  '#74b9ff',
  '#badc58',
  '#c7ecee',
];

export const PostMetaWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  text-align:center;

  .metaleft {
    width:50%;
    text-align:left;
    padding:0;
    margin:0;
  }
  
  .metaright {
    width: 50%;
    text-align:right;
    padding:0;
    margin:0;

  }

  div {

 
    font-family: 'Poppins';


    font-size: 12px;
    margin: 0px 10px;
    padding: 10px;

    cursor: pointer;
 
    text-transform: uppercase;

    span {

      font-size: 16px;
      color:#D10068;
      font-weight: 500;
      span {
        color: #222;
      }
       
    }

    
    @media (max-width: 600px) {
      font-size: 11px;
      padding: 5px;
      
      span {
        font-size: 15px;
      }
      &:nth-of-type(4) {
        margin-left:auto;
      }
    }

    
    
  }

  a {
    display: block;
    margin-right: 30px;
    font-size: 14px;
    font-weight: 400;
    color: ${themeGet('primary', '#D10068')};
  }

  

  div.ticketButton {
    background-color: #D10068;

    margin-left: auto;
    margin-right: auto;
    width: 300px;
    padding: 10px;
    margin-top:20px;
    transform:scale(1);
    border-radius: 6px;
    
    a {
      margin: 0;
      text-align: center;
      color: white;
      font-weight: bold;
      align-self: self-end;
      cursor: pointer;
    
    }
    &:hover {
      transform:scale(1.02);
      transition: all 0.5s ease-in-out;

    }      
  

  }
`;
